// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 40px 0;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.425);
}
.model .addItem {
  position: relative;
  background-color: #fff;
  margin: auto;
  width: 500px;
  padding-bottom: 20px;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  z-index: 125666;
}
.model .addItem .loading-spinner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 55;
  background-color: rgba(255, 255, 255, 0.466);
}
.model .addItem .head {
  width: 100%;
  padding: 20px;
  background-color: #f3f6f9;
  justify-content: space-between !important;
}
.model .addItem .head h5 {
  color: #495057;
  margin: 0;
}
.model .addItem .head svg {
  cursor: pointer;
  color: #898b8d;
}
.model .addItem .head svg:hover {
  color: #495057;
}
.model .addItem form {
  padding: 10px 20px;
  color: #495057;
  font-size: 14px;
}
.model .addItem form .logo {
  display: flex;
  align-items: center;
}
.model .addItem form .logo div:last-child {
  width: 100%;
}
.model .addItem form .logo img {
  margin-right: 10px;
  margin-top: 12px;
  max-width: 50px;
  height: 50px;
  border-radius: 5px;
}
.model .addItem form .error input {
  border-color: red;
  background-color: rgb(255, 194, 194) !important;
}
.model .addItem form label span {
  color: red;
}
.model .addItem form input {
  font-size: 14px;
}
.model .addItem form .buttons {
  display: flex;
  justify-content: flex-end;
}
.model .addItem form .buttons button {
  margin: 0;
  margin-left: 10px;
}
.model .show-enter {
  opacity: 0;
  transform: translateY(-100px);
}
.model .show-enter-active {
  transition: 400ms;
  opacity: 1;
  transform: translateY(0);
}
.model .show-enter-done {
  opacity: 1;
  transform: translateY(0);
}
.model .show-exit {
  transition: 0ms;
  opacity: 1;
}
.model .show-exit-active {
  transition: 400ms;
  opacity: 0;
}
.model .show-exit-done {
  opacity: 0;
}
.model .buttons {
  margin-top: 15px;
}

.model-show {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 600px) {
  .addItem {
    width: 90% !important;
  }
}
.dark .model .addItem {
  background-color: var(--darkSecondColor);
}
.dark .model .addItem .head {
  background-color: var(--darkMaincolor) !important;
}
.dark .model .addItem .head h5 {
  color: var(--darkFont);
}
.dark .model .addItem .head svg {
  color: var(--darkFont);
}
.dark .model .addItem form {
  color: var(--darkFont);
}
.dark .model .addItem form input,
.dark .model .addItem form textarea {
  background-color: var(--darkMaincolor) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/modelForm.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,sCAAA;AACF;AAAE;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AADI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,4CAAA;AAGN;AADI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,yCAAA;AAGN;AAFM;EACE,cAAA;EACA,SAAA;AAIR;AAFM;EACE,eAAA;EACA,cAAA;AAIR;AAFM;EACE,cAAA;AAIR;AADI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAGN;AAFM;EACE,aAAA;EACA,mBAAA;AAIR;AAHQ;EACE,WAAA;AAKV;AAHQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAKV;AADQ;EACE,iBAAA;EACA,+CAAA;AAGV;AACQ;EACE,UAAA;AACV;AAEM;EACE,eAAA;AAAR;AAEM;EACE,aAAA;EACA,yBAAA;AAAR;AACQ;EACE,SAAA;EACA,iBAAA;AACV;AAIE;EACE,UAAA;EACA,6BAAA;AAFJ;AAIE;EACE,iBAAA;EACA,UAAA;EACA,wBAAA;AAFJ;AAIE;EACE,UAAA;EACA,wBAAA;AAFJ;AAIE;EACE,eAAA;EACA,UAAA;AAFJ;AAIE;EACE,iBAAA;EACA,UAAA;AAFJ;AAIE;EACE,UAAA;AAFJ;AAIE;EACE,gBAAA;AAFJ;;AAKA;EACE,UAAA;EACA,mBAAA;AAFF;;AAIA;EACE;IACE,qBAAA;EADF;AACF;AAKI;EACE,wCAAA;AAHN;AAIM;EACE,iDAAA;AAFR;AAGQ;EACE,sBAAA;AADV;AAGQ;EACE,sBAAA;AADV;AAIM;EACE,sBAAA;AAFR;AAGQ;;EAEE,iDAAA;AADV","sourcesContent":[".model {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 40px 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 99999;\n  opacity: 0;\n  visibility: hidden;\n  background-color: rgba(0, 0, 0, 0.425);\n  .addItem {\n    position: relative;\n    background-color: #fff;\n    margin: auto;\n    width: 500px;\n    padding-bottom: 20px;\n    height: fit-content;\n    border-radius: 10px;\n    overflow: hidden;\n    z-index: 125666;\n    .loading-spinner {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      z-index: 55;\n      background-color: rgba(255, 255, 255, 0.466);\n    }\n    .head {\n      width: 100%;\n      padding: 20px;\n      background-color: #f3f6f9;\n      justify-content: space-between !important;\n      h5 {\n        color: #495057;\n        margin: 0;\n      }\n      svg {\n        cursor: pointer;\n        color: #898b8d;\n      }\n      svg:hover {\n        color: #495057;\n      }\n    }\n    form {\n      padding: 10px 20px;\n      color: #495057;\n      font-size: 14px;\n      .logo {\n        display: flex;\n        align-items: center;\n        div:last-child {\n          width: 100%;\n        }\n        img {\n          margin-right: 10px;\n          margin-top: 12px;\n          max-width: 50px;\n          height: 50px;\n          border-radius: 5px;\n        }\n      }\n      .error {\n        input {\n          border-color: red;\n          background-color: rgb(255, 194, 194) !important ;\n        }\n      }\n      label {\n        span {\n          color: red;\n        }\n      }\n      input {\n        font-size: 14px;\n      }\n      .buttons {\n        display: flex;\n        justify-content: flex-end;\n        button {\n          margin: 0;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n  .show-enter {\n    opacity: 0;\n    transform: translateY(-100px);\n  }\n  .show-enter-active {\n    transition: 400ms;\n    opacity: 1;\n    transform: translateY(0);\n  }\n  .show-enter-done {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  .show-exit {\n    transition: 0ms;\n    opacity: 1;\n  }\n  .show-exit-active {\n    transition: 400ms;\n    opacity: 0;\n  }\n  .show-exit-done {\n    opacity: 0;\n  }\n  .buttons {\n    margin-top: 15px;\n  }\n}\n.model-show {\n  opacity: 1;\n  visibility: visible;\n}\n@media (max-width: 600px) {\n  .addItem {\n    width: 90% !important;\n  }\n}\n.dark {\n  .model {\n    .addItem {\n      background-color: var(--darkSecondColor);\n      .head {\n        background-color: var(--darkMaincolor) !important;\n        h5 {\n          color: var(--darkFont);\n        }\n        svg {\n          color: var(--darkFont);\n        }\n      }\n      form {\n        color: var(--darkFont);\n        input,\n        textarea {\n          background-color: var(--darkMaincolor) !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
